import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { filter, withLatestFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SetLocationDialogComponent } from '../dialogs/set-location-dialog/set-location-dialog.component';
import { ConfigService } from './config.service';

@Injectable()
export class CurrentLocationService {
  private configService = inject(ConfigService);
  private destroyRef = inject(DestroyRef);
  private dialog = inject(MatDialog);
  currentLocation$ = this.configService.currentLocation;

  constructor() {}

  checkLocation() {
    this.configService.locations
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((locations) => !!locations),
        withLatestFrom(this.currentLocation$)
      )
      .subscribe(([locations, currentLocation]) => {
        if (!environment.production || locations.length === 1) {
          this.configService.setCurrentLocation(locations[0]);
          return;
        }
        if (!currentLocation && locations.length > 1) {
          this.editLocation();
        }
      });
  }

  editLocation() {
    if (this.dialog.openDialogs.length === 0) {
      setTimeout(() => {
        this.dialog.open(SetLocationDialogComponent, {
          disableClose: true
        });
      }, 200);
    }
  }
}
